import { Checkbox, Tooltip } from '@mui/material';
import React from 'react';

import DeribitIcon from '../../../assets/icons/deribit-icon.svg';
import OkxIcon from '../../../assets/icons/okx-icon.svg';
import OtcIcon from '../../../assets/icons/otc-icon.svg';
import './styles.scss';
import { IAccountOption } from '../../../providers/venue-provider';
import { BLUR_STYLE } from '../../../providers/demo-blur';
import Utils from '../../../utils/immersive_utils';

interface AggregatedAlphabeticalAccountListProps {
  credentials: any[];
  isPortfolioSidebarOpen: boolean;
  selectedAccountsAggregated: IAccountOption[];
  setSelectedAccountsAggregated: (items: IAccountOption[]) => void;
  // Opt-in "blur names for demo" (Portfolio Management/Performance). Off by default.
  isBlurred?: boolean;
}

export const AggregatedAlphabeticalAccountList: React.FC<
  AggregatedAlphabeticalAccountListProps
> = ({
  credentials,
  isPortfolioSidebarOpen,
  selectedAccountsAggregated,
  setSelectedAccountsAggregated,
  isBlurred = false,
}) => {
  const sortedAccounts = credentials
    .flatMap((credential) =>
      credential.items.map((item: any) => ({
        ...item,
        icon:
          item.exchange === 'deribit' ? DeribitIcon : item.exchange === 'okx' ? OkxIcon : OtcIcon,
      })),
    )
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter((item) => item.exchange !== 'binance');

  const hasOTCSelected = selectedAccountsAggregated.some((sel) => sel.exchange === 'otc');

  const handleSelectAllChange = (items: IAccountOption[], isChecked: boolean) => {
    const isOTC = items.some((item) => item.exchange === 'otc');
    const hasNonOTCSelected = selectedAccountsAggregated.some((sel) => sel.exchange !== 'otc');

    if (isChecked) {
      if (isOTC && hasNonOTCSelected) return;
      if (!isOTC && selectedAccountsAggregated.some((sel) => sel.exchange === 'otc')) return;
      const newItems = items.filter(
        (item) =>
          !selectedAccountsAggregated.some(
            (sel) => sel.name === item.name && sel.exchange === item.exchange,
          ),
      );
      setSelectedAccountsAggregated([...selectedAccountsAggregated, ...newItems]);
    } else {
      const newSelected = selectedAccountsAggregated.filter(
        (sel) => !items.some((item) => sel.name === item.name && sel.exchange === item.exchange),
      );
      setSelectedAccountsAggregated(newSelected);
    }
  };

  return (
    <div className="portfolio-accounts-aggregated-list">
      <div
        className={`portfolio-accounts-multi-select-list ${
          isPortfolioSidebarOpen ? 'portfolio-accounts-multi-select-hover' : ''
        }`}
      >
        {sortedAccounts.map((account, index) => (
          <Tooltip
            key={`${account.name}-${index}`}
            title={!isBlurred && account.name.length >= 20 ? account.name : ''}
          >
            <div className="portfolio-accounts-item">
              <Checkbox
                checked={selectedAccountsAggregated.some(
                  (sel) => sel.name === account.name && sel.exchange === account.exchange,
                )}
                onChange={(e) => handleSelectAllChange([account], e.target.checked)}
                disabled={hasOTCSelected && account.exchange !== 'otc'}
              />
              <img src={account.icon as string} alt={account.exchange} className="account-icon" />
              <span style={isBlurred ? BLUR_STYLE : undefined}>
                {Utils.truncateLabel(account.name)}
              </span>
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};
